import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateService } from '../services/date.service';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  constructor(
    private generalService: GeneralService,
    private dateService: DateService,
    private route: Router
  ) {}
  exist: boolean = false;
  listeEnenement = [];
  ngOnInit(): void {
    this.getListeEnenement();
    console.log(localStorage.getItem('lastVisitedRoute'));

    if (localStorage.getItem('lastVisitedRoute')) {
      this.route.navigate([localStorage.getItem('lastVisitedRoute')]);
    }

    let lastURLprefered = localStorage.getItem("lastURLprefered")
    if(this.loggedIn && lastURLprefered)
      {
        this.route.navigate([lastURLprefered])
        localStorage.removeItem("lastURLprefered")
      }
  }
  getListeEnenement() {
    this.exist = false;
    this.generalService
      .rechercheTable(this.generalService.url + 'avtEvenementMur')
      .subscribe((data) => {
        this.listeEnenement = data;
        this.listeEnenement.forEach((ev) => {
          this.getImage(ev);
        });
      });
  }
  getImage(evennement) {
    this.generalService
      .rechercheTable(
        this.generalService.urlFindDoc +
          evennement.Evenement_Code +
          ',' +
          'evenementImage' +
          ',' +
          'evenementImage'
      )
      .subscribe((data) => {
        if (data.length > 0) {
          evennement['image'] =
            data[data.length - 1].File_Autre +
            data[data.length - 1].File_Content;
        }
      });
  }

  public get loggedIn(): boolean {
    return (localStorage.getItem('token') !== null);
  }
}
